import classNames from "classnames";
import { ReactNode } from "react";

interface GradientBorderContainerProps {
  className?: string;
  classNameContainer?: string;
  children?: ReactNode;
  noBackdrop?: boolean;
  gradientColor?: "green" | "gray" | "black" | "transparent";
  onClick?: () => void;
}

export const GradientBorderContainer = ({
  className,
  classNameContainer,
  children,
  noBackdrop = false,
  gradientColor = "green",
  onClick,
}: GradientBorderContainerProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        "w-auto h-auto bg-gradient-to-br p-[1px] rounded-2xl transition-all",
        {
          "from-sendolab-gray to-business-green4 from-40%":
            gradientColor === "green",
          "from-black to-[#313131]": gradientColor === "gray",
          "from-[#151514] to-black": gradientColor === "black",
          "from-transparent to-transparent border-[2px] !p-0 border-sendolab-gray":
            gradientColor === "transparent",
          "hover:opacity-90 cursor-pointer": onClick,
        },
        className
      )}
    >
      <div
        className={classNames(
          "w-full h-full rounded-2xl p-4",
          {
            "backdrop-blur-md": !noBackdrop,
            "bg-sendolab-gray3": noBackdrop,
            "bg-black/85": gradientColor === "green",
            "bg-black/50": gradientColor === "gray",
            "bg-black/55": gradientColor === "black",
            "bg-sendolab-gray/15": gradientColor === "transparent",
          },
          classNameContainer
        )}
      >
        {children}
      </div>
    </div>
  );
};
